<template>
    <div class="layout">
        <el-container>
            <el-header height="50px">
                <rh-header></rh-header>
            </el-header>
            <el-container>
                <el-aside :width="menuVisible ? '200px' : '17px'">
                    <side-bar v-show="menuVisible"></side-bar>
                    <div class="layout-collapse">
                        <img :src="require(`@/assets/imgs/${menuVisible ? 'left' : 'right'}suo_icon.png`)" @click="menuVisible = !menuVisible">
                    </div>
                </el-aside>
                <el-main>
                    <div class="layout-main">
                        <tags-view></tags-view>
                        <app-main></app-main>
                    </div>
                </el-main>
            </el-container>
        </el-container>
    </div>
</template>
<script>
import AppMain from './comps/appMain.vue';
import RhHeader from './comps/rhHeader.vue';
import SideBar from './comps/sideBar.vue';
import TagsView from './comps/tagsView.vue';
import "./layout.less";
export default {
    name: "layout",
    data(){
        return {
            menuVisible:true
        };
    },
    components:{
        RhHeader,
        TagsView,
        SideBar,
        AppMain
    },
    methods: {},
};
</script>



// WEBPACK FOOTER //
// src/pages/layout/layout.vue